import { render, staticRenderFns } from "./FieldsetTextCreditParts.vue?vue&type=template&id=02635bb1&scoped=true"
import script from "./FieldsetTextCreditParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetTextCreditParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetTextCreditParts.vue?vue&type=style&index=0&id=02635bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02635bb1",
  null
  
)

export default component.exports